import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { award_event_id, GET_DASHBOARD_DATA_ACTION_TYPE, getDashboardDataUrl, headers, user_id } from "../../utils/constants";
export const get_dashboard_data_action =
  (award_event_profile_id, application_no,jury_id) => async (dispatch) => {
    try {
      const mapdata = {
        user_id: sessionStorage.getItem("user_id"),
        award_event_id: sessionStorage.getItem("award_event_id"),
        award_event_profile_id: award_event_profile_id != '' ? award_event_profile_id : null,
        application_no: application_no != '' ? application_no : null,
        jury_id: jury_id != '' ? jury_id : null,
      };
      const params = {
        user_id: mapdata.user_id === "" ? null : mapdata.user_id,
        award_event_id: mapdata.award_event_id === "" ? null : mapdata.award_event_id,
        award_event_profile_id: award_event_profile_id != '' ? award_event_profile_id : null,
        application_no: application_no != '' ? application_no : null,
        jury_id: jury_id != '' ? jury_id : null,
      };
      const res = await axiosGet(getDashboardDataUrl, params, headers);
      dispatch({
        type: GET_DASHBOARD_DATA_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };